// features/intelligence/tabs/domain-knowledge.js
// ═══════════════════════════════════════════════════════════
// DOMAIN KNOWLEDGE — the learning + research library.
// Where users go to understand things deeply, not just see
// today's data. Concept library + case studies + research
// tools + accumulated intelligence organized by concept.
//
// Layer 1: shell with sample concepts. Layer 2: pull from
// `domain_concepts` table. Layer 3: per-concept Practitioner
// Lens via Claude.
// ═══════════════════════════════════════════════════════════

const CONCEPTS = [
  { tag: 'Foundational', title: 'Market Regimes',           desc: 'The 4 regime types and how to identify each before you trade.', sessions: 8 },
  { tag: 'Foundational', title: 'Yield Curve Reading',      desc: 'Why 2/10 inversion matters less for traders than rate-of-change.', sessions: 5 },
  { tag: 'Tactical',     title: 'Gap Trading',              desc: 'Why pre-market gaps are setups, not trades — the first 30 minutes rule.', sessions: 12 },
  { tag: 'Tactical',     title: 'VIX Term Structure',       desc: 'Backwardation vs contango — when to sell premium and when to buy it.', sessions: 7 },
  { tag: 'Tactical',     title: 'Options Flow Reading',     desc: 'How to distinguish institutional positioning from retail noise.', sessions: 9 },
  { tag: 'Advanced',     title: 'Sector Rotation Signals',  desc: 'Why sector behavior leads the options market by 4-6 weeks.', sessions: 4 },
  { tag: 'Advanced',     title: 'Carry Trade Unwind',       desc: 'USD/JPY as the early warning system for risk-off cascades.', sessions: 3 },
  { tag: 'Personal',     title: 'Your Squeeze Edge',        desc: 'What conditions historically produce above-average outcomes for you.', sessions: 14, personal: true },
];

const TONES = {
  Foundational: '#5a9eb5', // teal
  Tactical:     '#c8a96e', // gold
  Advanced:     '#9b8fc4', // purple
  Personal:     '#7a9e82', // sage
};

export default function DomainKnowledgeTab() {
  return (
    <div className="di-scroll">
      <div className="di-section" style={{ marginBottom: 16 }}>
        <div className="di-sec-header">
          <div className="di-sec-label">Concept Library — Trading</div>
          <div className="di-sec-right">
            <div className="di-sec-time">{CONCEPTS.length} concepts · 62 sessions referenced</div>
          </div>
        </div>
        <div style={{ padding: 14, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }}>
          {CONCEPTS.map(c => (
            <div key={c.title} style={{
              background: '#111118', border: '1px solid #272736',
              borderTop: `2px solid ${TONES[c.tag]}`,
              borderRadius: 8, padding: '12px 14px', cursor: 'pointer',
            }}>
              <div style={{
                fontFamily: 'DM Mono, monospace', fontSize: 8,
                letterSpacing: '0.14em', textTransform: 'uppercase',
                color: TONES[c.tag], marginBottom: 8,
              }}>
                {c.tag}{c.personal ? ' · Yours' : ''}
              </div>
              <div style={{
                fontFamily: 'Cormorant Garamond, serif', fontSize: 17,
                color: '#f0eefa', marginBottom: 6,
              }}>
                {c.title}
              </div>
              <div style={{ fontSize: 12, color: '#888', lineHeight: 1.55, marginBottom: 10 }}>
                {c.desc}
              </div>
              <div style={{
                fontFamily: 'DM Mono, monospace', fontSize: 9,
                color: '#555',
              }}>
                {c.sessions} sessions · last referenced 2d ago
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="di-placeholder" style={{ height: 'auto', padding: '40px 20px' }}>
        <div className="di-eyebrow-tag">Coming next</div>
        <h2>Case studies + research tools</h2>
        <p>
          Patterns from your sessions become case studies. Search across every concept with
          full Practitioner Lens commentary. Connect any concept to live data on the Dashboard
          tab. Build the library that makes you smarter over time — not just informed for today.
        </p>
      </div>
    </div>
  );
}
